import { render, staticRenderFns } from "./descriptions.vue?vue&type=template&id=4cd61202&scoped=true"
import script from "./descriptions.vue?vue&type=script&lang=js"
export * from "./descriptions.vue?vue&type=script&lang=js"
import style0 from "./descriptions.vue?vue&type=style&index=0&id=4cd61202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd61202",
  null
  
)

export default component.exports